module.exports = __webpack_public_path__ + "img/line_qrcode.41a92bd7.svg";